import { render, staticRenderFns } from "./TG.vue?vue&type=template&id=a64f57fc&scoped=true&"
import script from "./TG.vue?vue&type=script&lang=js&"
export * from "./TG.vue?vue&type=script&lang=js&"
import style0 from "./TG.vue?vue&type=style&index=0&id=a64f57fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f57fc",
  null
  
)

export default component.exports